import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import { appendModel } from '../../../../features/site/siteSlice'
import { oauthConsts, OVERRIDE_ID_FB_PAGE } from '../../../utils/common'

const INITIAL_STATE = {
    account: {}
}

function FacebookInsights(props){
    const oauthConst = oauthConsts()

    const dispatch = useDispatch()
    const [state, setState] = useState(INITIAL_STATE)

    const isAdmin = useSelector(state => state.session.isAdmin)
    const model = useSelector(state => state.site.model)
    const oauthTokens = useSelector(state => state.session.oauthTokens)

    const AddAccParent = (p) => props.design === "onboarding" ? <div className="text-center">
        {p.children}
    </div> : <>{p.children}</>
    
    useEffect(() => {
        if(state.account !== INITIAL_STATE.account){

            let { account } = state 
            const map = {
                tokenId: oauthTokens.fbPage?.id,
                pageId: account.id,
                pageName: account.name
            }
            let dispatchIt = true

            if(model.siteForm?.attr?.accounts?.fbPage && oauthTokens.fbPage){
                let fbPage =oauthTokens.fbPage.accounts?.find(fbP => model.siteForm?.attr?.accounts?.fbPage?.pageId === fbP.id)
                
                if(!fbPage){
                    dispatchIt = false
                    toast.error("The Facebook Insights account chosen does not not have the permission to access this particular page. Please contact the system's administrator for more information")
                } else if(fbPage && fbPage.instagram_business_account){
                    map.igPageId = fbPage.instagram_business_account.id
                }
            } else if (account?.instagram_business_account){
                map.igPageId = account?.instagram_business_account.id
            }
            
            if(dispatchIt){
                let sForm = {
                    ...model.siteForm,
                    attr: {
                        ...model.siteForm.attr,
                        accounts: {
                            ...(model.siteForm.attr.accounts ? model.siteForm.attr.accounts : []),
                            fbPage: map
                        }
                    }
                }

                localStorage.setItem("fbPageSelection", JSON.stringify({
                    account: account.id,
                    accountKey: account.key,
                    map: JSON.stringify({...map})
                }))

                dispatch(appendModel({siteForm: sForm}))

                props.onSelectionUpdated("fbPage")
            }
        }
    }, [state.account])

    useEffect(() => {
        let fbPage = oauthTokens?.fbPage?.accounts?.find(fbP => model.siteForm?.attr?.accounts?.fbPage?.pageId === fbP.id)
        if(model.siteForm?.attr?.accounts?.fbPage && fbPage){
            const map = {
                tokenId: oauthTokens.fbPage?.id,
                ...siteForm.attr.accounts?.fbPage
            }
            
            if(fbPage?.instagram_business_account){
                map.igPageId = fbPage.instagram_business_account.id
                let sForm = {
                    ...model.siteForm,
                    attr: {
                        ...model.siteForm.attr,
                        accounts: {
                            ...(model.siteForm.attr.accounts ? model.siteForm.attr.accounts : []),
                            fbPage: map
                        }
                    }
                }
                dispatch(appendModel({siteForm: sForm}))
            }
        }
    }, [oauthTokens.fbPage])
    
    const { siteForm, sites, siteActiveIdx } = model
    const { account } = state

    const hrefOauth = `${oauthConst.fbPageAuthURL}&state=${props.design === "onboarding" ? "/onboarding/": "/admin/"}${siteForm.siteId}/fbPage`
    const site = sites[siteActiveIdx]

    return <>
        {(!model.reseller || (model.reseller && !model.isAffiliate)) && oauthTokens?.fbPage && !siteForm?.attr?.accounts?.fbPage && <>
            <div className="d-flex justify-content-end mb-3">
                <div className="btn-group">
                    <a href={hrefOauth} className="btn btn-lg btn-info">
                        <i class="fas fa-sync-alt"></i> Refresh
                    </a>
                </div>
            </div>
            <form>
                <div class="form-group">
                    <label for="acct">Facebook Page Account</label>
                    <select id="fbPage-acct" className="form-control" onChange={(e) => setState(prev => ({...prev, account: {...oauthTokens?.fbPage?.accounts[e.target.value], key: e.target.value}}))} value={account?.key}>
                        <option></option>
                        {oauthTokens?.fbPage?.accounts?.map((item, key) => <option key={key} value={key}>{item.name}</option>)}
                    </select>
                </div>
            </form>
        </>}
        {siteForm?.attr?.accounts?.fbPage && <div>
            {(!model.reseller || (model.reseller && !model.isAffiliate)) && sessionStorage.getItem(OVERRIDE_ID_FB_PAGE) && <h5 className="alert alert-info">
                Click the Save button to complete the reset token process
            </h5>}
            {(!model.reseller || (model.reseller && !model.isAffiliate)) && <div className={`d-flex justify-content-${isAdmin && siteForm?.attr?.accounts?.fbPage.refreshRequired ? 'between' : 'end'} mb-3`}>
                {isAdmin && siteForm?.attr?.accounts?.fbPage.refreshRequired && <div class="alert alert-danger mb-0" role="alert">
                    <strong>Next Alert Date:</strong> {siteForm?.attr?.accounts?.fbPage.refreshAlertDate}
                </div>}
                <div className="btn-group">
                    {!sessionStorage.getItem(OVERRIDE_ID_FB_PAGE) && siteForm?.attr?.accounts?.fbPage?.refreshRequired && <button className="btn btn-lg btn-danger" onClick={() => props.onResetToken("fbPage", hrefOauth)}>
                        <i class="fas fa-trash-alt"></i> Reset Token
                    </button>}
                    {props.design !== "onboarding" && !siteForm.attr?.accounts.fbPage?.igPageId && !siteForm?.attr?.accounts?.fbPage?.refreshRequired && <a href={hrefOauth} className="btn btn-lg btn-info">
                        <i class="fas fa-sync-alt"></i> Refresh
                    </a>}
                    {isAdmin && <button className="btn btn-lg btn-outline-danger" onClick={() => props.onDeleteService("fbPage")}>
                        <i class="fas fa-trash-alt"></i> Delete
                    </button>}
                </div>
            </div>}
            {isAdmin && <div className="d-flex justify-content-start">
                <i className="fas fa-id-badge mr-1 fa-1-5"></i>
                <strong className="mr-1">Token ID: </strong>
                <h5>{siteForm?.attr?.accounts?.fbPage?.tokenId}</h5>
            </div>}
            <h3>
                <small class="text-muted">Account Page:</small> <span id="fbPageAccountName">{siteForm.attr?.accounts.fbPage.pageName}</span>
                {account?.id && <a className="btn btn-sm btn-outline-primary ml-2" href={`https://www.facebook.com/${account.id}`} target="_blank">Test Page</a>}
            </h3>
            {siteForm.attr?.accounts.fbPage?.igPageId && <h4>
                <small class="text-muted">Instagram Page Id:</small> {siteForm.attr?.accounts.fbPage.igPageId}
            </h4>}
            {!siteForm.attr?.accounts.fbPage?.igPageId && siteForm.attr?.accounts.fbPage?.igPageId && <h4>
                <small class="text-muted">Instagram Page Id:</small> {siteForm.attr?.accounts.fbPage.igPageId} <small class="text-info">(Save to add IG)</small>
            </h4>}
        </div>}
        {(!model.reseller || (model.reseller && !model.isAffiliate)) && !siteForm?.attr?.accounts?.fbPage && !oauthTokens?.fbPage && <AddAccParent>
            <a class="btn btn-success btn-lg" href={hrefOauth}>Add Account</a>
        </AddAccParent>}
    </> 
}

FacebookInsights.defaultProps = {
    design: "admin",
    onSelectionUpdated: () => null
}

export default FacebookInsights